import React, { useState } from 'react';
import { connect } from "react-redux";
import { Card } from 'react-bootstrap';
import { toDisplayTimeString } from '../../../helpers/moment-ex';

const getBatteryLevel = level => {
    if (level >= 90 && level <= 100) return { state: 4, color: "#4caf50" };
    else if (level >= 70 && level < 90) return { state: 3, color: "#4caf50" };
    else if (level >= 50 && level < 70) return { state: 2, color: "#4caf50" };
    else if (level >= 25 && level < 50) return { state: 1, color: "#f7a32b" };
    else if (level >= 11 && level < 25) return { state: 1, color: "#FF0000" };
    else if (level >= 0 && level < 11) return { state: 0, color: "#FF0000" };
    else return { state: 0, color: "#FF0000" };
};

const getFuelLevel = level => {
    if (!level) return { color: "#a5a5a5" };
    if (level > 75 && level <= 100) return { color: "#4caf50" };
    else if (level > 25 && level <= 75) return { color: "#f7a32b" };
    else if (level >= 0 && level <= 25) return { color: "#FF0000" };
    else return { color: "#f74225" };
};

const DeviceCard = (props) => {
    const { deviceDetails, isRequesting, className } = props;
    const [showDetails, setShowDetails] = useState(false)

    const batteryLevel = getBatteryLevel(deviceDetails.batteryPercent);
    const fuelLevel = getFuelLevel(deviceDetails.fuelLevel);
    const ptoRpmUrl = deviceDetails.ptoRPMState ? require("../../../../assets/images/pto_rpm.svg") :
        require("../../../../assets/images/pto_rpm_stop.svg");

    return <Card className={`item-details ${showDetails && "active"} ${className}`} {...!isRequesting && { onClick: () => setShowDetails(!showDetails) }} >
        <Card.Header className="item-header d-flex">
            <div className="name" title={deviceDetails.deviceName}>
                {deviceDetails.deviceName}
            </div>
            {!isRequesting && <><div className="time">
                <i className={`fa ${deviceDetails.connected ? "fa-arrow-up" : "fa-arrow-down"} ${deviceDetails.connected ? "active" : ""} mr-2`} aria-hidden="true"></i>
                {deviceDetails.connectionUpTime ? toDisplayTimeString(deviceDetails.connectionUpTime) : "N/A"}
            </div>
                {!showDetails && <div className="wifi-details" title={`${deviceDetails.connected ? "Wifi connected" : "Wifi disconnected"}`}>
                    <i className={`fa fa-wifi ${deviceDetails.connected ? "connected" : ""}`} aria-hidden="true"></i>
                </div>}</>}
        </Card.Header>
        {!isRequesting && showDetails && <Card.Body className={`item-body d-flex`}>
            <div className="wifi-details" title={`${deviceDetails.connected ? "Wifi connected" : "Wifi disconnected"}`}>
                <i className={`fa fa-wifi  ${deviceDetails.connected ? "connected" : ""}`} aria-hidden="true"></i>
            </div>
            <div className="battery-details" title={`Battery level ${deviceDetails.batteryPercent}%`}>
                <i className={`fa fa-battery-${batteryLevel.state} mr-1`} style={{ color: batteryLevel.color }} />
                {deviceDetails.batteryPercent}%
            </div>
            {!deviceDetails.isTruck && <div className="pto-details" title={`${deviceDetails.ptoRPMState ? deviceDetails.ptoRPMSpeed + " rpm" : ""}`}>
                <><img src={ptoRpmUrl} className={`icon-pto ${!deviceDetails.ptoRPMState && "disconnect"}`} alt="" />
                    {deviceDetails.ptoRPMState && `${deviceDetails.ptoRPMSpeed}`} rpm</>
            </div>}
            <div className="fuel-details" title={`Fuel level ${deviceDetails.fuelLevel ? `${deviceDetails.fuelLevel}%` : "N/A"}`}>
                <i className={`icon icon-fuel mr-1`} style={{ color: fuelLevel.color }} />
                {deviceDetails.fuelLevel ? `${deviceDetails.fuelLevel}%` : "N/A"}
            </div>
        </Card.Body>}
    </Card>
}

const mapStateToProps = (state, ownProps) => {
    return ({
        deviceDetails: state.farmMonitor.deviceById.payload[ownProps.id],
        isRequesting: state.farmMonitor.deviceById.isRequestingSensorKpi
    });
}

export default connect(mapStateToProps)(DeviceCard);